;(function ( viselySearchExtension, undefined ) {
  
    let domParser = new DOMParser();
  
    document.addEventListener("DOMContentLoaded", () => {
      let results = document.querySelector('div.search-results');
      if(results) {
        let screen = window.getComputedStyle(results, ':before').getPropertyValue('content').replace(/\"/g, '');
        if (screen == 'large') {
          results.classList.toggle('open');
        }
      }
  	});


    function displayRecommendations(shouldDisplay) {
      let wrapper = document.querySelector('.visely-search-wrapper');
      if (wrapper && shouldDisplay) {
        wrapper.classList.add('no-results');
      } else if (wrapper) {
        wrapper.classList.remove('no-results');
      }
    }

    function attachFacetToggle(element){
      let facets = Array.from(element.querySelectorAll('.search-product-facet-title:not([data-handler-init])'));
      facets.forEach(facet => {
        facet.addEventListener('mousedown', function(e){
          facet.parentElement.classList.toggle('open');
        });
        let chevron = document.createElement('i');
        chevron.classList.add("fa");
        chevron.classList.add("fa-chevron-down");
        facet.appendChild(chevron);
        if (!facet.parentElement.querySelector('li.selected')) {
        	facet.parentElement.classList.toggle('open');
        }
        facet.setAttribute('data-handler-init','true');
      })
    }
    
    function buildRatings(product, ratingsParser) {
      	var div = document.createElement('div');
      	if (product.meta && JSON.parse(product.meta)['okendo|ReviewAverageValue'] > 0) {          
          div.classList.add('okendo-reviews-star-rating')
          div.setAttribute('data-oke-reviews-product-id','shopify-' + product.id);        
          let json = JSON.parse(product.meta);
          div.innerHTML = ratingsParser ? ratingsParser(json['okendo|ProductListingSnippet']) : json['okendo|ProductListingSnippet'];
        } else {
          div.classList.add('search-results-no-rating');
        }
        
     	return div;
    }

    function buildLocation(product) {
      	var div = document.createElement('div');
      	if (product.meta && JSON.parse(product.meta)['global|product-region']) { 
          let json = JSON.parse(product.meta);
          div.classList.add('region-infor');
          let p = document.createElement('p');
          p.innerText = json['global|product-region'];
          div.appendChild(p);
        } else {
          div.classList.add('region-infor');
          let p = document.createElement('p');
          p.innerHTML = "&nbsp;";
          div.appendChild(p);
        } 
        return div;
    }

	function buildSummaryExcerpt(product) {
      	var div = document.createElement('div');
      	if (product.summary && product.summary.en) { 
          div.classList.add('summary-excerpt');
          let p = document.createElement('p');
          p.innerHTML = product.summary.en.trim();
          div.appendChild(p);
        }  
        return div;
    }

    function buildDispatch(product) {
       var div = document.createElement('div');
       div.classList.add("search-dispatch");
       let isInStock = JSON.parse(product.variants).filter(v => v.inStock && v.stockLevel > 0).length > 0;
        if (isInStock) {
          div.innerHTML = `<div class='stock-msg'>
              <span class='in-stock'><i class="fa fa-check"></i></span><span class='shipping-msg'>DISPATCHED NEXT BUSINESS DAY</span>
          </div>`
        } else if (product.meta && JSON.parse(product.meta)['global|pre-order-message']) { 
          let json = JSON.parse(product.meta);
          div.innerHTML = `<div class='stock-msg'>
            <span class='pre-order'><i class="fa fa-exclamation"></i><!-- DELAYED SHIPPING--></span><span class='shipping-msg'>${json['global|pre-order-message']}</span>
          </div>`
        } else {
          div.innerHTML = `<div class='stock-msg'>
            <span class='pre-order'><i class="fa fa-exclamation"></i><!-- DELAYED SHIPPING--></span><span class='shipping-msg'>DISPATCHED IN 3 – 5 BUSINESS DAYS</span>
          </div>`
        }

        return div;
    }

    function buildListViewPrices(li, cart) {
      let prices = li.querySelector('.search-price-list');
      let listViewPrices = prices.cloneNode(true);
      cart.insertBefore(listViewPrices, cart.childNodes[0]);
    }

    function buildSaleBadge() {
      let div = document.createElement('div');
      div.classList.add('product-labels');
      div.classList.add('labels-rounded');
      div.innerHTML = `<span class="onsale product-label">Sale</span></div>`;
      return div;
    }

    function buildAddToCart(product, element, container) {
      let div = document.createElement('div');
      div.classList.add('add-to-cart-holder');
      let mainAnchor = element.querySelector("a");
      let position = mainAnchor.dataset.searchResultPosition;
      let availablevariants = (Array.isArray(product.variants) ? product.variants : JSON.parse(product.variants)).filter(v => v.inStock);
       
      div.innerHTML = availablevariants.length > 0 ? `<div class="quick-shop-wrapper">
         <div class="quick-shop-btn">
			<a rel="nofollow" href="${product.relUrl}" data-pid="${availablevariants[0].id}" class="button product_type_simple add_to_cart_button ajax_add_to_cart">Add to cart</a>
         </div>
		<div class="quick-shop-form" id="product-${product.id}"></div>
	  </div>` : `<div class="quick-shop-wrapper">
         <div class="quick-shop-btn">
			<a rel="nofollow" href="${product.relUrl}" class="button product_type_simple add_to_cart_button btn-out-stock">Out of Stock</a>
         </div>
	  </div>`
        
      
      let a = div.querySelector('a'); 
      if (a) {
        a.addEventListener('mousedown', function(e){
          document.dispatchEvent(new CustomEvent('viselySearchResultsClickExternalHandler', { detail: { 
            additionalAttributes: {
              variationId: container.variationId,
              experimentName: container.experimentName,
              widgetType: container.searchResultType,
              productName: product.name.en
            },
            searchTerms: container.q,
            searchResultType: container.searchResultType,
            productId: product.id,
            position: position
          }}));
          document.dispatchEvent(new CustomEvent('viselySearchResultsAddToCartExternalHandler', { detail: {productId: product.id}}));
        });
      }
  
      return div;
    }

    function buildAddToCartAndWishlist(product, element, container) {
      let div = document.createElement('div');
      div.classList.add('cart-wishlist');
      let cart = document.createElement('div');
      cart.classList.add('add-to-cart-holder');
      let mainAnchor = element.querySelector("a");
      let position = mainAnchor.dataset.searchResultPosition;
      
      let availablevariants = (Array.isArray(product.variants) ? product.variants : JSON.parse(product.variants)).filter(v => v.inStock);
      
      
      cart.innerHTML = availablevariants.length > 0 ? `<div class="quick-shop-wrapper">
         <div class="quick-shop-btn">
			<a rel="nofollow" href="${product.relUrl}" data-pid="${availablevariants[0].id}" class="button product_type_simple add_to_cart_button ajax_add_to_cart">Add to cart</a>
         </div>
		<div class="quick-shop-form" id="product-${product.id}"></div>
	  </div>` : `<div class="quick-shop-wrapper">
         <div class="quick-shop-btn">
			<a rel="nofollow" href="${product.relUrl}" class="button product_type_simple add_to_cart_button btn-out-stock">Out of Stock</a>
         </div>
	  </div>`
        
      
      let a = cart.querySelector('a'); 
      if (a) {
        a.addEventListener('mousedown', function(e){
          document.dispatchEvent(new CustomEvent('viselySearchResultsClickExternalHandler', { detail: { 
            additionalAttributes: {
              variationId: container.variationId,
              experimentName: container.experimentName,
              widgetType: container.searchResultType,
              productName: product.name.en
            },
            searchTerms: container.q,
            searchResultType: container.searchResultType,
            productId: product.id,
            position: position
          }}));
          document.dispatchEvent(new CustomEvent('viselySearchResultsAddToCartExternalHandler', { detail: {productId: product.id}}));
        });
      }
      div.appendChild(cart);
      let wishlist = document.createElement('div');
      wishlist.classList.add('basel-buttons');
    
      //       Swym Integration 
      function swymCallbackFn(){
        if (ViselyContext.currentCustomer) {
        if (window._swat) {
          wishlist.innerHTML = `<div class="wishlist-container">
      			<div class="yith-wcwl-add-to-wishlist add-to-wishlist-${product.id}">
					<div class="yith-wcwl-add-button">
                      <a data-with-epi="true" data-swaction="addToWishlist" data-product-id="${product.id}" data-variant-id="${availablevariants[0].id}" rel="nofollow" class="swym-add-to-wishlist-view-product product_${product.id} add_nitro_wishlist add_to_wishlist basel-tooltip"><span class="basel-tooltip-label swym-wishlist-cta">Add to Wishlist</span><span class="swym-wishlist-cta"></span></a>
                    </div>
				</div>
                </div><div class="clear"></div>`
        }
      } else {
      	  wishlist.innerHTML = `<div class="wishlist-container">
          <div class="yith-wcwl-add-to-wishlist add-to-wishlist-${product.id} ">

              <div class="yith-wcwl-add-button">
                  <a href="/account" rel="nofollow" class="nitro_wishlist_login add_to_wishlist basel-tooltip">
                  <span class="basel-tooltip-label">Login to use Wishlist</span>Login to use Wishlist</a>
              </div>
          </div>
          </div><div class="clear"></div>`
      }
        
      div.appendChild(wishlist); 
      window._swat.initializeActionButtons(".search-results-main-content");
      
      }
      if(!window.SwymCallbacks){
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(swymCallbackFn);

   
      return div;
    }

    function addFlairBadgeToSearchResults(product, element) {
      let flair = document.createElement('div');
      
      flair.classList.add("summary-badges");
      flair.innerHTML = domParser.parseFromString(product.flairbadge, "text/html").documentElement.textContent;
            
      let tile =  element.querySelector('[data-visely-product-id="'+ product.id + '"]');
      let li = tile.parentElement.parentElement.parentElement;
      let summary = li.querySelector('.search-summary a');
      summary.insertBefore(flair, summary.childNodes[2]);
    }

	function addFlairBadgeToSearchSuggestions(product, element) {
      let flair = document.createElement('div');
      
      flair.classList.add("summary-badges");
      flair.innerHTML = domParser.parseFromString(product.flairbadge, "text/html").documentElement.textContent;
            
      let summary = element.querySelector('.search-summary [data-visely-product-id="'+ product.id + '"]');
      let badges = element.querySelector('.search-summary [data-visely-product-id="'+ product.id + '"] .summary-badges');
      if (summary && !badges) {
        summary.insertBefore(flair, summary.childNodes[0]);
      }
	}


    document.addEventListener('search.results.rendered', function (e) { 
      let element = e.detail.element;
      products = e.detail.products;
      
      let panel = element.querySelector('.search-results-panel');
      
      let resultsHeader = e.detail.element.querySelector('.search-results-header');
      let panelResultsHeader = panel.querySelector('.search-results-header');
      
      if (panelResultsHeader) {
        panel.replaceChild(resultsHeader, panelResultsHeader);
      } else {
        panel.appendChild(resultsHeader);
      }
      
      
      
      if(products) {
        products.forEach(function(product) {
          var tile = element.querySelector('[data-visely-product-id="'+ product.id + '"]');
          var li = tile.parentElement.parentElement.parentElement;
          var summary = li.querySelector('.search-summary a');
          var searchItem = li.querySelector('div.search-item');
          
          summary.innerHTML = '';
          var location = buildLocation(product);
          summary.appendChild(location);
          var summaryExcerpt = buildSummaryExcerpt(product);
          summary.appendChild(summaryExcerpt);
          var dispatch = buildDispatch(product);
          summary.appendChild(dispatch);
          var ratings = buildRatings(product);
          summary.appendChild(ratings);
          if (product.variants && !li.classList.contains('basel-hover-quick')) {
            li.classList.add('basel-hover-quick');
            var cart = buildAddToCartAndWishlist(product, li, e.detail);
            if (product.prices.filter(p => p.priceType == 'SALE').length > 0) {
              tile.parentNode.insertBefore(buildSaleBadge(), tile.nextSibling)
            }
            searchItem.parentNode.insertBefore(cart, searchItem.nextSibling);
            buildListViewPrices(li, cart);
          }
        });
        attachFacetToggle(element);
        
        viselySearchApi.productDetails(products.map(product => product.id)).then(
          details => {
            Array.from(details).forEach(product => {
              addFlairBadgeToSearchResults(product, element);
            });
          }
        );
      }
      displayRecommendations(!(e.detail.meta && e.detail.meta.total > 0));
      //       Init button after recommendations loads.
      if(window._swat){window._swat.initializeActionButtons("body")};
      
    }, false);
    document.addEventListener('search.results.provided', function (e) { 
    }, false);
    document.addEventListener('search.suggestions.rendered', function (e) {
      let element = e.detail.element;
      let products = e.detail.product;
      let recentlyviewed = e.detail.recentlyviewed;
      let f = (items, ratingsParser) => {
         if(items) {
            items.forEach(function(product) {
              var tile = element.querySelector('[data-visely-product-id="'+ product.id + '"]');
              if (tile) {
                var li = tile.parentElement.parentElement;
                var summary = li.querySelector('.search-summary a');
               
                summary.innerHTML = '';
                var additional = buildRatings(product, ratingsParser);
                summary.appendChild(additional);
                if (product.variants && !li.classList.contains('basel-hover-quick')) {
                  li.classList.add('basel-hover-quick');
                  var cart = buildAddToCart(product, li, e.detail);
                  tile.parentNode.insertBefore(cart, tile.nextSibling)
                }
              }
            });
           	viselySearchApi.productDetails(items.map(product => product.id)).then(
              details => {
                Array.from(details).forEach(product => {
                  addFlairBadgeToSearchSuggestions(product, element);
                });
              }
            );
          }
      }
      
      f(products);
      f(recentlyviewed, data => domParser.parseFromString(data, "text/html").documentElement.textContent);
      function swymCallbackFn(swat){
        //       Swym Initialize after an Ajax of search.
        //         Product page Init
        swat.initializeActionButtons("body");
        //         Collections Page Init
        swat.initializeActionButtons("#Collections");
      }
      if(!window.SwymCallbacks){
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(swymCallbackFn);

        
    }, false);
    document.addEventListener('search.suggestions.provided', function (e) { 
    }, false);

    viselySearchExtension.wrapSearchSuggestions = function (container) {
        return container;
    };
  
    viselySearchExtension.wrapSearchResults = function (container) {
    //  	console.log(container)
//       return viselySearchApi.productDetails(container.data.products.map(p => p.id))
//       .then((details) => {
//         container.data.products = container.data.products.map(p => {
//           let a = details.filter(d => d.id == p.id)[0];
//           return {...p, "flairbadge":a.flairbadge};
//         });
//         console.log(container.data.products);                                                      
//         return container;
//       });
      return container;
    };
}( window.viselySearchExtension = window.viselySearchExtension || {} ));